import { render } from "./Transfers.vue?vue&type=template&id=71c00766&scoped=true&ts=true"
import script from "./Transfers.vue?vue&type=script&lang=ts"
export * from "./Transfers.vue?vue&type=script&lang=ts"

import "./Transfers.vue?vue&type=style&index=0&id=71c00766&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71c00766"]])

export default __exports__